<template>
  <div class="attestation-lang">
    <span>{{ $t("test_language") }}:</span>
    <button
      v-for="item in languages"
      :key="item.code"
      type="button"
      :class="{ active: item.code === current }"
      @click="choose(item.code)"
    >
      {{ item.label }}
    </button>
  </div>
</template>

<script>
export default {
  name: "AttestationLangSwitch",
  data() {
    return {
      languages: [
        { code: "latn", label: "O‘zbekcha" },
        { code: "cyrl", label: "Ўзбекча" },
        { code: "ru", label: "Русский" },
      ],
    };
  },
  computed: {
    current() {
      return this.$store.getters.attestationLang;
    },
  },
  methods: {
    choose(code) {
      if (code === this.current) return;
      this.$store.commit("setAttestationLang", code);
      this.$emit("change");
    },
  },
};
</script>

<style scoped>
.attestation-lang {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin: 12px 0 20px;
}
.attestation-lang button {
  padding: 6px 14px;
  border: 1px solid #c5d2de;
  border-radius: 8px;
  background: #fff;
  color: #333;
  cursor: pointer;
}
.attestation-lang button.active {
  border-color: #bd282b;
  background: #bd282b;
  color: #fff;
}
</style>
